
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/magic-eraser",
      function () {
        return require("private-next-pages/magic-eraser/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/magic-eraser"])
      });
    }
  